import { Badge } from '@/ui';

type Props = {
  onDark?: boolean;
};

export const DefaultViewBadge = ({ onDark }: Props) => (
  <Badge
    bg={onDark ? 'whiteAlpha.300' : undefined}
    color={onDark ? 'white' : undefined}
    flexShrink={0}
    variant="defaultView"
  >
    Default
  </Badge>
);
